import React from 'react';
import { Badge } from 'components';

type Props = {
  value: string;
};

type Variant = 'success' | 'danger' | 'warning';

const allocationStatuses = {
  Allocated: 'success',
  Unallocated: 'danger',
  'Not Allocated': 'warning'
};

const AllocationStatus = ({ value }: Props) => {
  return value ? <Badge variant={(allocationStatuses as any)[value] as Variant} value={value} /> : <span />;
};

export default AllocationStatus;
